import './App.css';
import { proverbs } from "./data/proverbs";
import ProverbDisplay from './components/ProverbDisplay';
import { useState } from 'react';

import { searchInProverbs } from './lib/search';
import { groupProverbs } from './lib/group-proverbs';
import SearchBox from './components/SearchBox';

const groupedProverbs = groupProverbs(proverbs);

const themeOptions: { value: string, label: string }[] = groupedProverbs.map(g => ({
  value: g.theme,
  label: g.theme,
}));

function App() {
  // const [searchMode, setSearchMode] = useState<"none" | "theme">("none");
  const [themesSelected, setThemesSelected] = useState<string[]>([]);
  const [search, setSearch] = useState<string>("");
  const grouped = themesSelected.length
    ? groupedProverbs.filter((g) => themesSelected.includes(g.theme))
    : groupedProverbs;
  const searched = search
    ? groupProverbs(searchInProverbs(search, proverbs))
    : grouped;
  return (
    <div className="App">
      <div style={{ margin: "3.5rem 0"}}>
        <h1>Love Grows by Coming and Going</h1>
        <h1>مینه په تلو راتلو زیاتېږی</h1>
        <h2>Popular Pashto Proverbs</h2>
        <h3>By Robert Sampson</h3>
        <div style={{ marginTop: "2rem" }}>Digital version - Click proverbs for audio</div>
        <div style={{ marginTop: "0.5rem" }}><a href="https://www.amazon.com/Grows-Coming-Going-%D8%B1%D8%A7%D8%AA%D9%84%D9%88-%D8%B2%D9%8A%D8%A7%D8%AA%DB%90%DA%96%DB%8C/dp/B0B2TVHKRG">Paperback available on Amazon</a></div>
      </div>
      <SearchBox
        onSearchValueChange={setSearch}
        onThemesSelectedChange={setThemesSelected}
        searchValue={search}
        themesSelected={themesSelected}
        themeOptions={themeOptions}
      />
      {searched.length === 0 && <div style={{ margin: "3rem 0"}}>
        None found
      </div>}
      {searched.map(({ theme, proverbs }) => <div key={theme}>
        <h3>{theme}</h3>
        {proverbs.map(proverb => (
          <ProverbDisplay key={proverb.p1}>
            {proverb}
          </ProverbDisplay>
        ))}
      </div>)}
      <div style={{ fontSize: "0.5rem", color: "grey", margin: "5rem 0", lineHeight: "1.4" }}>
            <div style={{ marginBottom: "1rem"}}>Copyright © 2022 Sampson, Robert</div>
            <div>All Rights Reserved</div>
        </div>
    </div>
  );
}

export default App;
